import { render, staticRenderFns } from "./IconActionContentLayout.vue?vue&type=template&id=2833883f&scoped=true&"
var script = {}
import style0 from "./IconActionContentLayout.vue?vue&type=style&index=0&id=2833883f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2833883f",
  null
  
)

export default component.exports